import React from "react";
import {
  PlusCircle,
  CreditCard,
  DollarSign,
  CheckCircle,
  X,
  Trash2,
  Link2,
} from "react-feather";

const stop = (event) => {
  event.stopPropagation();
};

const ActionButton = ({ type = "default", icon, label, title, onClick, compact = false }) => (
  <button
    type="button"
    className={`ns-table-action-btn ${type} ${compact ? "compact" : ""}`}
    onClick={(event) => {
      stop(event);
      onClick?.(event);
    }}
    title={title || label}
    aria-label={title || label}
  >
    {icon}
    {!compact && label ? <span>{label}</span> : null}
  </button>
);

const TableActions = ({
  status,
  group,
  groupIndex,
  handleTableClick,
  handleAddKOT,
  handleUnmerge,
  handleOpenBillingPanel,
  isMerged,
  showBilling,
}) => {
  const primaryTable = Array.isArray(group) && group.length > 0 ? group[0] : null;

  if (!primaryTable) return null;

  const canAddKOT = status === "Available" || status === "Occupied";
  const canBill = status === "Occupied" && showBilling;
  const isReserved = status === "Reserved";
  const isDirty = status === "Dirty";

  return (
    <>
      <div className={`ns-table-actions ${isMerged ? "merged" : ""}`}>
        {canAddKOT && (
          <ActionButton
            type="primary"
            icon={<PlusCircle size={15} />}
            label="KOT"
            title={`Add KOT for ${primaryTable.name || "table"}`}
            onClick={() => handleAddKOT?.(primaryTable)}
          />
        )}

        {canBill && (
          <ActionButton
            type="success"
            icon={isMerged ? <CreditCard size={15} /> : <DollarSign size={15} />}
            label="Bill"
            title={`Generate bill for ${primaryTable.name || "table"}`}
            onClick={() => handleOpenBillingPanel?.(primaryTable.id)}
          />
        )}

        {isReserved && (
          <>
            <ActionButton
              type="success"
              icon={<CheckCircle size={15} />}
              label="Confirm"
              title={`Confirm reservation for ${primaryTable.name || "table"}`}
              onClick={() => handleTableClick?.(primaryTable, "confirm")}
            />
            <ActionButton
              type="danger"
              icon={<X size={15} />}
              label="Cancel"
              title={`Cancel reservation for ${primaryTable.name || "table"}`}
              onClick={() => handleTableClick?.(primaryTable, "cancel")}
            />
          </>
        )}

        {isDirty && (
          <ActionButton
            type="warning"
            icon={<Trash2 size={15} />}
            label="Clean"
            title={`Mark ${primaryTable.name || "table"} as clean`}
            onClick={() => handleTableClick?.(primaryTable, "clean")}
          />
        )}
      </div>

      {isMerged && (
        <button
          type="button"
          className="ns-table-unmerge-btn"
          onClick={(event) => {
            stop(event);
            handleUnmerge?.(groupIndex);
          }}
          title="Unmerge tables"
          aria-label="Unmerge tables"
        >
          <Link2 size={15} />
        </button>
      )}
    </>
  );
};

export default TableActions;
